<template>
    <div v-loading="loading">
        <el-form class="form" label-width="100px" ref="ruleForm" :model="form" :rules="rules">
            <el-form-item label="内容：" prop="broadcastContent">
                <el-input
                        v-model="form.broadcastContent"
                        type="textarea"
                        placeholder="内容最大100字符"
                        rows="3"
                        maxLength="100"
                        resize="none"/>
            </el-form-item>
            <el-form-item label="次数：" prop="broadcastCount">
                <el-input class="block" v-model.number="form.broadcastCount" type="number" placeholder="默认为1次"/>
            </el-form-item>
            <el-form-item label="时间：" prop="broadcastTime">
                <el-date-picker
                        v-model="form.broadcastTime"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="请选择时间"
                        type="datetime"/>
            </el-form-item>
            <el-form-item label="范围：" prop="sendType">
                <el-select class="block" v-model="form.sendType">
                    <el-option
                            v-for="item of sendTypeOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"/>
                </el-select>
            </el-form-item>
            <el-form-item v-show="form.sendType === '2'" prop="roomPaths">
                <el-select v-model="form.roomPaths" multiple
                           placeholder="请选择牌局类型">
                    <el-option
                            v-for="item of roomPathOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"/>
                </el-select>
            </el-form-item>
            <el-form-item v-show="form.sendType === '3'" prop="roomId">
                <el-input placeholder="请输入房间号" v-model="form.roomId">
                    <el-select style="width: 150px" v-model="form.roomPath" placeholder="请选择房间类型" slot="prepend">
                        <el-option
                                v-for="item of roomPathOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"/>
                    </el-select>
                </el-input>
            </el-form-item>
            <el-form-item v-show="form.sendType === '4'" prop="broadcastTribe">
                <el-input placeholder="请输入联盟ID" v-model="form.broadcastTribe"/>
            </el-form-item>
            <el-form-item v-show="form.sendType === '5'" prop="broadcastClub">
                <el-input placeholder="请输入俱乐部ID" v-model="form.broadcastClub"/>
            </el-form-item>
            <div class="footer">
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import {roomPathOptions} from 'mixins'

    export default {
        mixins: [roomPathOptions],
        data() {
            return {
                loading:false,
                sendTypeOptions: [
                    {label: '全服广播', value: '1'},
                    {label: '牌局广播', value: '2'},
                    {label: '指定房间', value: '3'},
                    {label: '指定联盟', value: '4'},
                    {label: '指定俱乐部', value: '5'},
                ],
                form: {
                    broadcastContent: '',//广播内容
                    broadcastCount: '',// 广播次数
                    broadcastTime: null,//广播时间
                    sendType: '1',//范围
                    roomPaths: [],//牌局广播的牌局类型
                    roomPath: '61',//房间的牌局类型
                    roomId: '',// 房间ID
                    broadcastTribe: '',// 联盟ID
                    broadcastClub: '',// 俱乐部ID
                },
                rules: {
                    broadcastContent: [
                        {required: true, message: '请输入内容', trigger: 'blur'}
                    ],
                    broadcastCount: [
                        {
                            validator: (rule, value, callback) => {
                                if (value !== '' && !Number.isInteger(value)) {
                                    callback(new Error('次数应为大于0的整数'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    broadcastTime: [
                        {required: true, message: '请选择时间', trigger: 'blur'}
                    ],
                    roomPaths: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.form.sendType === '2' && !value.length) {
                                    callback(new Error('请选择牌局类型'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    roomId: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.form.sendType === '3' && !value.length) {
                                    callback(new Error('请输入房间号'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    broadcastTribe: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.form.sendType === '4' && !value.length) {
                                    callback(new Error('请输入联盟ID'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ],
                    broadcastClub: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.form.sendType === '5' && !value.length) {
                                    callback(new Error('请输入俱乐部ID'))
                                } else {
                                    callback()
                                }
                            }, trigger: 'blur'
                        }
                    ]
                }
            }
        },
        methods: {
            ...mapActions('system', ['createBroadcast']),
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = Object.assign({}, this.form, {
                            roomPaths: this.form.roomPaths.join(',')
                        });
                        this.loading = true;
                        this.createBroadcast(params).then(() => {
                            this.loading = false;
                            this.$message.success('请求成功');
                            this.$refs[formName].resetFields();
                        })
                    }
                });
            },
        }
    }
</script>
<style lang="scss" scoped>
    .form {
        position: absolute;
        top: 15%;
        left: 50%;
        transform: translateX(-50%);
        width: 500px;

        :global(.el-date-editor) {
            width: 100% !important;
        }
        :global(.el-select) {
            width: 100%;
        }
    }

    .footer {
        padding: 20px 0 0 100px;
        text-align: center;
        :global(.el-button) {
            width: 150px;
            margin-bottom: 20px;
        }
    }
</style>